import { Box, styled } from '@mui/material';

import { ONE_HOUR } from '../../../../config/constants';
import { ganttPxPerMs } from './gantt.constants';

export const GanttTimelineStepLabelBox = styled(Box)`
    font-variant-numeric: tabular-nums; // all number are the same width
    color: ${({ theme }) => theme.palette.blue.lightest};
    font-family: Roboto, serif;
    font-size: 12px;
    font-weight: bold;
    line-height: 14px;
    letter-spacing: 0;
    width: 16px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    overflow: visible;
`;
export const GanttTimelineBox = styled(Box)`
    position: sticky;
    top: 0;
    z-index: 11;
    display: flex;
    width: fit-content;
    align-items: center;
    background: ${({ theme }) => theme.palette.background.default};
    padding-top: 5px;
    padding-bottom: 4px;
`;
export const GanttTimelineStepBox = styled(Box)`
    display: flex;
    align-items: center;
    width: ${ONE_HOUR * ganttPxPerMs}px;
    flex-shrink: 0;
`;
export const GanttTimelineStepLineBox = styled(Box)`
    height: 0;
    flex: 1;
    border-top: 1px dashed ${({ theme }) => theme.palette.blue.lightest};
    margin-left: 5px;
    margin-right: 20px;
`;
